import "./TablaEmpleadosInternos.css";

// import hooks, context y librerías
import React, { useContext, useEffect, useState } from "react";
import Swal from "sweetalert2";
import { DarkModeContext } from "../../context/DarkModeContext";
import { Button, Form } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCirclePlus } from "@fortawesome/free-solid-svg-icons";

// componente de fila
import ItemTablaEmpleadosInternos from "./ItemTablaEmpleadosInternos";

// MODAL REAL
import ModalEmpleado from "./ModalEmpleado";
import { getToken } from "../../utils/auth";
 // <-- revisa la ruta si lo moviste

const TablaEmpleadosInternos = () => {
    const { darkMode } = useContext(DarkModeContext);
    const [busqueda, setBusqueda] = useState("");
    const [empleados, setEmpleados] = useState([]);
    const [filtrados, setFiltrados] = useState([]);
    const [modalShow, setModalShow] = useState(false);

    const apiUrl = process.env.REACT_APP_API_EMPLEADO_INTERNO_OBTENER;

    const fetchEmpleados = async () => {
        try {
            const token = getToken();
            const response = await fetch(apiUrl, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ Token: token }),
            });
            if (!response.ok) throw new Error("Error al obtener empleados internos");
            const data = await response.json();
            setEmpleados(data);
            filtrarEmpleados(busqueda, data);
        } catch (error) {
            console.error("Error:", error);
            Swal.fire("Error", "No se pudieron cargar los empleados.", "error");
        }
    };

    const filtrarEmpleados = (texto, lista) => {
        const busq = texto.toLowerCase();
        const resultados = lista.filter(
            (emp) =>
                (emp.nombre && emp.nombre.toLowerCase().includes(busq)) ||
                (emp.apellido && emp.apellido.toLowerCase().includes(busq)) ||
                (emp.dni && emp.dni.includes(busq))
        );
        setFiltrados(resultados);
    };

    useEffect(() => {
        fetchEmpleados();
    }, []);

    useEffect(() => {
        filtrarEmpleados(busqueda, empleados);
    }, [busqueda, empleados]);

    const handleSearchChange = (e) => setBusqueda(e.target.value);

    const actualizarDatos = fetchEmpleados;

    return (
        <div
            className={
                darkMode
                    ? "container bg-tabla-usuarios-liquidaciones-dark"
                    : "container bg-tabla-usuarios-liquidaciones"
            }
        >
            <section className="container mt-3 mb-3">
                <div className="d-flex flex-wrap justify-content-between pt-4">
                    <div className="margin-centrado-responsive">
                        <div className="my-3 d-flex">
                            <h6 className="my-3 me-3 fs-18-a-16">Filtrar:</h6>
                            <div className="campo-busqueda">
                                <Form.Group className="d-flex justify-content-center">
                                    <Form.Control
                                        className={
                                            darkMode
                                                ? "form-control text-white label-buscador-cupones-dark lato-regular fs-18 border-0"
                                                : "form-control label-buscador-cupones lato-regular fs-18 border-0"
                                        }
                                        type="text"
                                        placeholder="Buscar por Nombre, Apellido o DNI"
                                        value={busqueda}
                                        onChange={handleSearchChange}
                                    />
                                </Form.Group>
                            </div>
                        </div>
                    </div>
                    <div className="d-flex centrado-responsive">
                        <div className="pt-3">
                            <Button
                                className="btn-modal-nuevo-usuario-editar centrado border-0 mx-2"
                                onClick={() => setModalShow(true)}
                            >
                                <FontAwesomeIcon icon={faCirclePlus} />{" "}
                                <span className="lato-bold fs-18 ms-2">Nuevo</span>
                            </Button>
                        </div>
                        {/* MODAL DE ALTA REAL */}
                        <ModalEmpleado
                            show={modalShow}
                            onHide={() => setModalShow(false)}
                            onActualizarDatos={actualizarDatos}
                            empleado={null} // importante, así es "alta"
                        />
                    </div>
                </div>
            </section>
            <article>
                <div
                    style={{
                        maxHeight: "70vh",
                        overflowY: "auto",
                        overflowX: "auto",
                        minWidth: "1700px"
                    }}
                    className="container table-responsive py-3 px-5"
                >
                    <table className="table table-borderless striped hover">
                        <thead>
                            <tr className="text-center tabla-thead">
                                <th className={darkMode ? "bg-dark text-white border-0 lato-regular fs-12 py-3" : "bg-dark text-white border-0 lato-regular fs-12 py-3"}>#</th>
                                <th className={darkMode ? "bg-dark text-white border-0 lato-regular fs-12 py-3" : "bg-dark text-white border-0 lato-regular fs-12 py-3"}>Legajo</th>
                                <th className={darkMode ? "bg-dark text-white border-0 lato-regular fs-12 py-3" : "bg-dark text-white border-0 lato-regular fs-12 py-3"}>Razón Social</th>
                                <th className={darkMode ? "bg-dark text-white border-0 lato-regular fs-12 py-3" : "bg-dark text-white border-0 lato-regular fs-12 py-3"}>Estado</th>
                                <th className={darkMode ? "bg-dark text-white border-0 lato-regular fs-12 py-3" : "bg-dark text-white border-0 lato-regular fs-12 py-3"}>Apellido</th>
                                <th className={darkMode ? "bg-dark text-white border-0 lato-regular fs-12 py-3" : "bg-dark text-white border-0 lato-regular fs-12 py-3"}>Nombre</th>
                                <th className={darkMode ? "bg-dark text-white border-0 lato-regular fs-12 py-3" : "bg-dark text-white border-0 lato-regular fs-12 py-3"}>DNI</th>
                                <th className={darkMode ? "bg-dark text-white border-0 lato-regular fs-12 py-3" : "bg-dark text-white border-0 lato-regular fs-12 py-3"}>CUIL</th>
                                <th className={darkMode ? "bg-dark text-white border-0 lato-regular fs-12 py-3" : "bg-dark text-white border-0 lato-regular fs-12 py-3"}>Domicilio</th>
                                <th className={darkMode ? "bg-dark text-white border-0 lato-regular fs-12 py-3" : "bg-dark text-white border-0 lato-regular fs-12 py-3"}>Ciudad</th>
                                <th className={darkMode ? "bg-dark text-white border-0 lato-regular fs-12 py-3" : "bg-dark text-white border-0 lato-regular fs-12 py-3"}>Provincia</th>
                                <th className={darkMode ? "bg-dark text-white border-0 lato-regular fs-12 py-3" : "bg-dark text-white border-0 lato-regular fs-12 py-3"}>Código Postal</th>
                                <th className={darkMode ? "bg-dark text-white border-0 lato-regular fs-12 py-3" : "bg-dark text-white border-0 lato-regular fs-12 py-3"}>Fecha Nac.</th>
                                <th className={darkMode ? "bg-dark text-white border-0 lato-regular fs-12 py-3" : "bg-dark text-white border-0 lato-regular fs-12 py-3"}>Celular</th>
                                <th className={darkMode ? "bg-dark text-white border-0 lato-regular fs-12 py-3" : "bg-dark text-white border-0 lato-regular fs-12 py-3"}>Email</th>
                                <th className={darkMode ? "bg-dark text-white border-0 lato-regular fs-12 py-3" : "bg-dark text-white border-0 lato-regular fs-12 py-3"}>Estado Civil</th>
                                <th className={darkMode ? "bg-dark text-white border-0 lato-regular fs-12 py-3" : "bg-dark text-white border-0 lato-regular fs-12 py-3"}>Emergencia</th>
                                <th className={darkMode ? "bg-dark text-white border-0 lato-regular fs-12 py-3" : "bg-dark text-white border-0 lato-regular fs-12 py-3"}>Hijos Dep.</th>
                                <th className={darkMode ? "bg-dark text-white border-0 lato-regular fs-12 py-3" : "bg-dark text-white border-0 lato-regular fs-12 py-3"}>Parentesco 1</th>
                                <th className={darkMode ? "bg-dark text-white border-0 lato-regular fs-12 py-3" : "bg-dark text-white border-0 lato-regular fs-12 py-3"}>Parentesco 2</th>
                                <th className={darkMode ? "bg-dark text-white border-0 lato-regular fs-12 py-3" : "bg-dark text-white border-0 lato-regular fs-12 py-3"}>Parentesco 3</th>
                                <th className={darkMode ? "bg-dark text-white border-0 lato-regular fs-12 py-3" : "bg-dark text-white border-0 lato-regular fs-12 py-3"}>Parentesco 4</th>
                                <th className={darkMode ? "bg-dark text-white border-0 lato-regular fs-12 py-3" : "bg-dark text-white border-0 lato-regular fs-12 py-3"}>Parentesco 5</th>
                                <th className={darkMode ? "bg-dark text-white border-0 lato-regular fs-12 py-3" : "bg-dark text-white border-0 lato-regular fs-12 py-3"}>Secundarios</th>
                                <th className={darkMode ? "bg-dark text-white border-0 lato-regular fs-12 py-3" : "bg-dark text-white border-0 lato-regular fs-12 py-3"}>Terciarios/Univ</th>
                                <th className={darkMode ? "bg-dark text-white border-0 lato-regular fs-12 py-3" : "bg-dark text-white border-0 lato-regular fs-12 py-3"}>Posgrado</th>
                                <th className={darkMode ? "bg-dark text-white border-0 lato-regular fs-12 py-3" : "bg-dark text-white border-0 lato-regular fs-12 py-3"}>Fecha Ingreso</th>
                                <th className={darkMode ? "bg-dark text-white border-0 lato-regular fs-12 py-3" : "bg-dark text-white border-0 lato-regular fs-12 py-3"}>Área</th>
                                <th className={darkMode ? "bg-dark text-white border-0 lato-regular fs-12 py-3" : "bg-dark text-white border-0 lato-regular fs-12 py-3"}>Puesto</th>
                                <th className={darkMode ? "bg-dark text-white border-0 lato-regular fs-12 py-3" : "bg-dark text-white border-0 lato-regular fs-12 py-3"}>Horario Laboral</th>
                                <th className={darkMode ? "bg-dark text-white border-0 lato-regular fs-12 py-3" : "bg-dark text-white border-0 lato-regular fs-12 py-3"}>CBU</th>
                                <th className={darkMode ? "bg-dark text-white border-0 lato-regular fs-12 py-3" : "bg-dark text-white border-0 lato-regular fs-12 py-3"}>Alias</th>
                                <th className={darkMode ? "bg-dark text-white border-0 lato-regular fs-12 py-3" : "bg-dark text-white border-0 lato-regular fs-12 py-3"}>Banco</th>
                                <th className={darkMode ? "bg-dark text-white border-0 lato-regular fs-12 py-3" : "bg-dark text-white border-0 lato-regular fs-12 py-3"}>PDF CBU</th>
                                <th className={darkMode ? "bg-dark text-white border-0 lato-regular fs-12 py-3" : "bg-dark text-white border-0 lato-regular fs-12 py-3"}>Validado</th>
                                <th className={darkMode ? "bg-dark text-white border-0 lato-regular fs-12 py-3" : "bg-dark text-white border-0 lato-regular fs-12 py-3"}>Correos Corp.</th>
                                <th className={darkMode ? "bg-dark text-white border-0 lato-regular fs-12 py-3" : "bg-dark text-white border-0 lato-regular fs-12 py-3"}>Modalidad</th>
                                <th className={darkMode ? "bg-dark text-white border-0 lato-regular fs-12 py-3" : "bg-dark text-white border-0 lato-regular fs-12 py-3"}>Tipo Servicio</th>
                                <th className={darkMode ? "bg-dark text-white border-0 lato-regular fs-12 py-3" : "bg-dark text-white border-0 lato-regular fs-12 py-3"}>Fecha Alta</th>
                                <th className={darkMode ? "bg-dark text-white border-0 lato-regular fs-12 py-3" : "bg-dark text-white border-0 lato-regular fs-12 py-3"}>Hs Trabajo</th>
                                <th className={darkMode ? "bg-dark text-white border-0 lato-regular fs-12 py-3" : "bg-dark text-white border-0 lato-regular fs-12 py-3"}>Fecha Baja</th>
                            </tr>
                        </thead>
                        <tbody className="text-center">
                            {filtrados.length > 0 ? (
                                filtrados.map((emp, i) => (
                                    <ItemTablaEmpleadosInternos
                                        key={emp.id || i}
                                        index={i + 1}
                                        empleado={emp}
                                        onActualizarDatos={actualizarDatos}
                                    />
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="41" className="lato-bold fs-12-a-10">
                                        No se encontraron empleados para esta búsqueda.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </article>
        </div>
    );
};

export default TablaEmpleadosInternos;
